import {
  DeleteOutline as DeleteOutlinedIcon,
  DragHandle as DragIcon,
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import React from 'react';
import { SortableKnob } from 'react-easy-sort';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { useGetProducts } from 'src/hooks';
import { getPlainText, useUserRole } from 'src/utils';
import { getProductLineupLabel } from 'src/utils/gcf-helper';

import { ProductLineProps } from './ProductLine.interface';
import {
  FlexGrid,
  IconContainer,
  ProductLineContainer,
  ProductLineIcon,
  ProductLineId,
  ProductLineName,
  SortableKnobIcon,
} from './ProductLine.styled';

export const ProductLine = (props: ProductLineProps) => {
  // TODO: Make this optional if any name_override is available or product has an actual name
  const { data: [currentProduct] = [] } = useGetProducts(
    [`product_code=${props.gcfProduct.productCode}`],
    [],
    {
      enabled: !!props.gcfProduct.productCode,
    },
  );
  const label = getPlainText(
    getProductLineupLabel(props.gcfProduct, currentProduct),
  );

  const { isOwnerOperator } = useUserRole();

  const isBackup = props.gcfProduct?.config?.isBackupProduct === true;
  const shouldShowEditableControlsForBackups = isBackup
    ? !isOwnerOperator
    : !props.hideDeleteButton;

  React.useEffect(() => {
    props.setSeed(props.seed + 1);
  }, [label]); // eslint-disable-line

  return (
    <ProductLineContainer>
      <IconContainer>
        {shouldShowEditableControlsForBackups && (
          <SortableKnobIcon>
            <SortableKnob>
              <DragIcon />
            </SortableKnob>
          </SortableKnobIcon>
        )}
      </IconContainer>
      <Grid container>
        <FlexGrid item md={11}>
          <ProductLineId>{props.gcfProduct.productCode}</ProductLineId>
          <ProductLineName
            $width={20}
            variant="text"
            onClick={props.onEdit}
            disabled={props.isDisabled}>
            <CustomTooltip
              key={label}
              width={500}
              placement="right"
              title={label}
              overflowLineNumber={1}>
              <p>{label}</p>
            </CustomTooltip>
          </ProductLineName>
        </FlexGrid>
        <Grid item md={1}>
          <IconContainer>
            {shouldShowEditableControlsForBackups && (
              <ProductLineIcon onClick={props.onDelete}>
                <DeleteOutlinedIcon color="error" />
              </ProductLineIcon>
            )}
          </IconContainer>
        </Grid>
      </Grid>
    </ProductLineContainer>
  );
};
